module.exports = __webpack_public_path__ + "8ab790b99815a08abbd6d152e47b0aef.pdf";